import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../../utils/hooks';
import { useTableExpandableSectionClassNames } from './utils/useTableExpandableSectionClassNames';
import { useTableExpandableSection } from './utils/useTableExpandableSection';
import { TableExpandableSectionRoot, TableExpandableSectionCell, TableExpandableSectionContent } from './style';
import { TABLE_EXPANDABLE_SECTION_CLASS_PREFIX } from './constants';
export var TableExpandableSection = forwardRef(function TableExpandableSection(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(TABLE_EXPANDABLE_SECTION_CLASS_PREFIX);
  var classNameComponents = useTableExpandableSectionClassNames(TABLE_EXPANDABLE_SECTION_CLASS_PREFIX, className);

  var _useTableExpandableSe = useTableExpandableSection(restProps),
      rootProps = _useTableExpandableSe.rootProps,
      cellProps = _useTableExpandableSe.cellProps,
      contentProps = _useTableExpandableSe.contentProps;

  return React.createElement(TableExpandableSectionRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNameComponents.Root,
    ref: ref
  }), React.createElement(TableExpandableSectionCell, Object.assign({}, cellProps, {
    theme: theme,
    className: classNameComponents.Cell
  }), React.createElement(TableExpandableSectionContent, Object.assign({}, contentProps, {
    theme: theme,
    className: classNameComponents.Content
  }), children)));
});
TableExpandableSection.defaultProps = {
  expanded: false,
  enableDefaultPadding: true
};